export class LaborDownload {
    /**
     * @type {Element}
     */
    target = null;

    /**
     * @type {HTMLFormElement|null}
     */
    form = null;

    /**
     * @type {HTMLAnchorElement|null}
     */
    downloadLinkElement = null;

    /**
     * @type {HTMLButtonElement|null}
     */
    buttonShow = null;

    /**
     * @type {HTMLButtonElement|null}
     */
    buttonClose = null;

    /**
     * @type {HTMLDialogElement}
     */
    dialog = null;

    /**
     *
     * @type {string|null}
     */
    fileDownloadUrl = null;

    /**
     * @param {Element} target
     */
    constructor(target) {
        this.target = target;

        this.buttonShow = target.querySelector('button.dialog-show');
        this.buttonClose = target.querySelector('button.dialog-close');
        this.dialog = target.querySelector('dialog');

        this.form = target.querySelector('form');
        this.fileDownloadUrl = this.form?.dataset.downloadUrl?.trim().length > 0 ? this.form?.dataset.downloadUrl : null;

        if (this.fileDownloadUrl === null) {
            console.error(`LaborDownload: No download url found for content element with uid ${this.target.closest('.frame').getAttribute('id')}`);
            return;
        }

        // remove the attribute so that it is no longer visible in the DOM
        this.form.removeAttribute('data-download-url');

        this.downloadLinkElement = this.target.querySelector('.button-download a');

        this.setupEventHandler();
    }

    /**
     * Append event handler to buttons.
     *
     * @protected
     * @return void
     */
    setupEventHandler() {
        this.buttonShow?.addEventListener('click', (e) => {
            this.showPopup();
        });

        this.buttonClose?.addEventListener('click', (e) => {
            this.closePopup();
        });

        this.dialog.addEventListener('click', (e) => {
            if (e.target === this.dialog) {
                this.closePopup();
            }
        });

        this.dialog.addEventListener('close', (e) => {
            this.uncheckAllCheckboxes();
            this.disableFileDownloadButton();
        });

        this.form.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
            checkbox.addEventListener('change', (e) => {
                if (this.form.checkValidity()) {
                    this.enableFileDownloadButton();
                } else {
                    this.disableFileDownloadButton();
                }
            });
        });

        this.downloadLinkElement.addEventListener('click', (e) => {
            setTimeout(() => {
                this.closePopup();
            }, 500);
        });
    }

     enableFileDownloadButton(){
        this.downloadLinkElement.setAttribute('href', this.fileDownloadUrl);
        // this.downloadLinkElement.setAttribute('download', this.fileDownloadUrl.substring(this.fileDownloadUrl.lastIndexOf('/') + 1));
        this.downloadLinkElement.setAttribute('download', '');
    }

    disableFileDownloadButton(){
        this.downloadLinkElement.removeAttribute('href');
        this.downloadLinkElement.removeAttribute('download');
    }

    uncheckAllCheckboxes(){
        this.form.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
            checkbox.checked = false;
        });
    }

    showPopup(){
        this.dialog.showModal();
    }

    closePopup(){
        this.dialog.close();
    }
}
